var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-field',[_c('label',[_vm._v(_vm._s(_vm.label))]),(!_vm.isDisabled)?_c('md-input',{attrs:{"value":_vm.value.reduce(_vm.reducer)}}):_c('md-input',{attrs:{"value":_vm.value.reduce(_vm.reducer),"disabled":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }